(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-block"] && !Shopify.designMode) return;
  try {
    
  // The phone number and the "when" field only appear once the visitor
  // ticks "Proszę o telefon"; before that the form is name, e-mail and
  // message. After a post the confirmation, or the list of errors, takes
  // focus, so a screen reader hears it and the visitor lands on it.
  // Runs again for a section the theme editor re-renders (audit F005).
  (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-contact-callback]').forEach((box) => {
        if (box.dataset.cnsReady) return;
        box.dataset.cnsReady = '1';
        const form = box.closest('form');
        if (!form) return;
        const fields = form.querySelectorAll('[data-contact-callback-field]');
        const phone = form.querySelector('[data-contact-phone]');
        const optional = form.querySelector('[data-contact-optional]');
        // Asking for a call makes the number required; the "(opcjonalnie)"
        // hint goes with it (audit V025).
        const sync = () => {
          fields.forEach((field) => {
            field.hidden = !box.checked;
          });
          if (phone) phone.required = box.checked;
          if (optional) optional.hidden = box.checked;
        };
        box.addEventListener('change', sync);
        sync();
      });

      // The browser's own bubble vanishes and cannot be read back; each
      // empty or wrong field gets its message under it instead (audit V029).
      scope.querySelectorAll('.cns-contact__form').forEach((form) => {
        if (form.dataset.cnsValidate) return;
        form.dataset.cnsValidate = '1';
        const messages = form.querySelector('[data-contact-messages]');
        if (!messages) return;
        form.noValidate = true;
        // A phone number: digits with spaces, +, -, brackets, and 9 to 15
        // digits in all (a Polish number, with or without +48).
        const validPhone = (value) => /^[+\d\s()-]+$/.test(value.trim()) && value.replace(/\D/g, '').length >= 9 && value.replace(/\D/g, '').length <= 15;
        const errorFor = (field) => form.querySelector(`#${field.id}-error`);
        const setError = (field, text) => {
          const error = errorFor(field);
          if (!error) return;
          error.textContent = text || '';
          error.hidden = !text;
          if (text) {
            field.setAttribute('aria-invalid', 'true');
            field.setAttribute('aria-describedby', error.id);
          } else {
            field.removeAttribute('aria-invalid');
            field.removeAttribute('aria-describedby');
          }
        };
        // Capture phase, and a stop on error: Shopify's hCaptcha listens for
        // the same submit on this form and on document, and would otherwise
        // run its challenge and then submit the invalid form natively
        // (audit H005).
        form.addEventListener('submit', (event) => {
          let first = null;
          form.querySelectorAll('[data-contact-required], [data-contact-phone]').forEach((field) => {
            if (!field.required || field.closest('[hidden]')) { setError(field, ''); return; }
            let text = '';
            if (!field.value.trim()) text = messages.dataset.requiredText;
            else if (field.type === 'email' && field.validity.typeMismatch) text = messages.dataset.emailText;
            else if (field.type === 'tel' && !validPhone(field.value)) text = messages.dataset.phoneText;
            setError(field, text);
            if (text && !first) first = field;
          });
          if (first) {
            event.preventDefault();
            event.stopImmediatePropagation();
            first.focus();
          }
        }, { capture: true });
        form.addEventListener('input', (event) => {
          if (event.target.matches('[data-contact-required], [data-contact-phone]')) setError(event.target, '');
        });
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));

    // "Wyślij kolejną wiadomość": the fields come back in place.
    document.addEventListener('click', (event) => {
      const again = event.target.closest && event.target.closest('[data-contact-again]');
      if (!again) return;
      const form = again.closest('form');
      const body = form && form.querySelector('[data-contact-body]');
      const sent = form && form.querySelector('[data-contact-success]');
      if (!body || !sent) return;
      event.preventDefault();
      sent.remove();
      body.hidden = false;
      const first = body.querySelector('input:not([type=hidden]), textarea');
      if (first) first.focus();
    });

    // The result shows where the form was, clear of the sticky header.
    const result = document.querySelector('[data-contact-errors], [data-contact-success]');
    if (result) {
      result.scrollIntoView({ block: 'center' });
      result.focus({ preventScroll: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  // A link to one question (…/najczestsze-pytania#faq-dostawa) opens it; the
  // browser has already scrolled to it, and scrolls again once it is open.
  (() => {
    const openTarget = () => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || !target.matches('details[data-faq-item]')) return;
      target.open = true;
      target.scrollIntoView({ block: 'start' });
    };

    window.addEventListener('hashchange', openTarget);
    openTarget();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Two narrow jobs: close the footer disclosures below the theme's breakpoint
  // (they ship open, so a visitor without JavaScript loses nothing), and reveal
  // the cookie control only where Shopify's banner API is actually present.
  // Runs again for a footer the theme editor re-renders (audit F006).
  (function () {
    var wide = window.matchMedia('(min-width: 48rem)');

    var init = function (scope) {
      var footer = scope.querySelector('.cns-footer');
      if (!footer || footer.dataset.cnsReady) return;
      footer.dataset.cnsReady = '1';

      var groups = footer.querySelectorAll('[data-cns-footer-group]');
      if (groups.length) {
        // From the breakpoint up the columns are always open and their
        // summaries are plain headings, so they leave the tab order too
        // (audit F265).
        var apply = function () {
          for (var i = 0; i < groups.length; i++) {
            groups[i].open = wide.matches;
            var summary = groups[i].querySelector('summary');
            if (!summary) continue;
            if (wide.matches) summary.setAttribute('tabindex', '-1');
            else summary.removeAttribute('tabindex');
          }
        };
        apply();
        if (wide.addEventListener) wide.addEventListener('change', apply);
        footer.cnsCleanup = function () {
          if (wide.removeEventListener) wide.removeEventListener('change', apply);
        };
      }

      var button = footer.querySelector('[data-cns-cookie-settings]');
      if (!button) return;

      // Shopify injects its banner script asynchronously, so a single check on
      // load reveals the control only sometimes. Poll briefly instead, and give
      // up quietly after five seconds rather than show a button that does nothing.
      var ready = function () {
        return !!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');
      };
      var tries = 0;
      var reveal = function () {
        if (ready()) {
          button.hidden = false;
          return;
        }
        if (++tries < 25) window.setTimeout(reveal, 200);
      };
      reveal();

      button.addEventListener('click', function () {
        if (ready()) window.privacyBanner.showPreferences();
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var footer = event.target.querySelector('.cns-footer');
      if (footer && footer.cnsCleanup) footer.cnsCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cns-guarantee-bar')) {
    customElements.define('cns-guarantee-bar', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.cns-guarantee-section');

        // Always pinned — there's no unpinned state for this bar, unlike
        // the nav below it. Set it immediately so there's no flash of
        // unpinned/uncollapsed layout before the first measurement.
        this.classList.add('is-pinned');

        this.updateHeight = () => {
          const height = this.getBoundingClientRect().height;
          if (this.section) this.section.style.height = `${height}px`;
          document.documentElement.style.setProperty('--cns-guarantee-height', `${height}px`);
          document.dispatchEvent(new CustomEvent('cns:offset-change', { detail: { guaranteeHeight: height } }));
        };
        this.observer = new ResizeObserver(this.updateHeight);
        this.observer.observe(this);
        this.updateHeight();
        document.fonts.ready.then(() => {
          if (this.isConnected) this.updateHeight();
        });

        // Steps through the rendered messages every 5s, one after another,
        // behind a short opacity fade. Only runs when a second message is
        // set; otherwise the bar just shows its static text. The href
        // travels with the message (data-guarantee-link): each one points
        // at its own page. A bar rendered as a <p> has no href to move, so
        // only the messages change.
        //
        // The rotation holds still while the pointer or keyboard focus is
        // on the bar (a link must not change under the finger or the Tab
        // key), while the tab is in the background, and never starts for
        // someone who asked the system for reduced motion (WCAG 2.2.2;
        // audit F247, F181, F245).
        const content = this.querySelector('.cns-guarantee__content');
        const messages = content ? content.querySelectorAll('.cns-guarantee__message') : [];
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (content && messages.length > 1 && !reduceMotion) {
          const isLink = content.hasAttribute('href');
          let current = 0;
          const holds = new Set();

          const swap = () => {
            content.classList.add('is-swapping');
            window.setTimeout(() => {
              messages[current].hidden = true;
              current = (current + 1) % messages.length;
              messages[current].hidden = false;
              if (isLink && messages[current].dataset.guaranteeLink) {
                content.setAttribute('href', messages[current].dataset.guaranteeLink);
              }
              content.classList.remove('is-swapping');
            }, 200);
          };
          const sync = () => {
            window.clearInterval(this.rotationTimer);
            this.rotationTimer = holds.size ? null : window.setInterval(swap, 5000);
          };
          const hold = (reason) => { holds.add(reason); sync(); };
          const release = (reason) => { holds.delete(reason); sync(); };

          this.addEventListener('mouseenter', () => hold('pointer'));
          this.addEventListener('mouseleave', () => release('pointer'));
          this.addEventListener('focusin', () => hold('focus'));
          this.addEventListener('focusout', () => release('focus'));
          this.onVisibility = () => (document.hidden ? hold('hidden') : release('hidden'));
          document.addEventListener('visibilitychange', this.onVisibility);
          sync();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        window.clearInterval(this.rotationTimer);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (!document.querySelector('cns-guarantee-bar')) {
          document.documentElement.style.setProperty('--cns-guarantee-height', '0px');
          document.dispatchEvent(new CustomEvent('cns:offset-change', { detail: { guaranteeHeight: 0 } }));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The one "add to cart in place" request (audit F183), used by the
  // product buy form and the catalogue's card buttons. It posts to the
  // cart's add URL and asks, in the same round trip, for the section that
  // holds the cart panel, then resolves with what happened:
  //   { outcome: 'added', sections } — the caller announces nothing; this
  //     dispatches `cns:cart-refresh` (added: true) so the panel opens;
  //   { outcome: 'refused' } — Shopify said no (sold out, a limit), or
  //     answered with an HTML page (a rate limit);
  //   { outcome: 'offline' } — no answer at all;
  //   { outcome: 'no-panel' } — no panel to show it in: go to /cart.
  // `body` is FormData (the form as it stands) or a plain object that is
  // sent as JSON (several items at once). Returns null when there is no
  // cart panel or no fetch, so the caller lets its form submit normally.
  window.cnsAddToCart = function (addUrl, body, trigger) {
    var panel = document.getElementById('cns-cart-panel');
    var section = panel && panel.closest('.shopify-section');
    if (!section || !addUrl || !window.fetch) return null;
    var sectionId = section.id.replace('shopify-section-', '');
    var init = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body instanceof FormData) {
      body.append('sections', sectionId);
      body.append('sections_url', window.location.pathname);
      init.body = body;
    } else {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(Object.assign({}, body, { sections: sectionId, sections_url: window.location.pathname }));
    }
    return fetch(addUrl + '.js', init).then(
      function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) return { outcome: 'refused' };
          if (!data.sections || !data.sections[sectionId]) return { outcome: 'no-panel' };
          document.dispatchEvent(new CustomEvent('cns:cart-refresh', {
            detail: { sections: data.sections, added: true, trigger: trigger },
          }));
          return { outcome: 'added', sections: data.sections };
        });
      },
      function () {
        return { outcome: 'offline' };
      }
    );
  };

  if (!customElements.get('cns-sticky-nav')) {
    customElements.define('cns-sticky-nav', class extends HTMLElement {
      connectedCallback() {
        // A 1px marker of our own sits in normal flow right before this bar
        // (its margin takes the pixel back, so nothing moves). Once it
        // scrolls above the bar's pin line, the bar pins. It used to be the
        // distributor strip above the bar, so removing or moving that
        // section in the editor stopped the pinning (audit F180).
        this.section = this.closest('.cns-nav-section');
        this.sentinel = document.createElement('div');
        this.sentinel.setAttribute('aria-hidden', 'true');
        this.sentinel.style.cssText = 'height:1px;margin-top:-1px;pointer-events:none;';
        (this.section || this).before(this.sentinel);
        this.handleOffsetChange = this.handleOffsetChange.bind(this);
        this.updateSpacer = this.updateSpacer.bind(this);
        this.updateNavHeight = this.updateNavHeight.bind(this);
        this.handleOffsetChange();
        document.addEventListener('cns:offset-change', this.handleOffsetChange);

        // Keeps the wrapper's reserved height in sync while pinned (e.g. if
        // the bar's own height changes after a font swap or text reflow),
        // and the anchor offset in sync at any time.
        this.resizeObserver = new ResizeObserver(() => {
          this.updateSpacer();
          this.updateNavHeight();
        });
        this.resizeObserver.observe(this);
        this.updateNavHeight();
        document.fonts.ready.then(() => {
          if (this.isConnected) this.updateNavHeight();
        });
        this.watchScroll();
      }

      // Feeds the global scroll-padding-block-start in critical.css, which
      // adds this to the guarantee bar's own height. Reported unconditionally,
      // not only while pinned: any anchor jump down the page ends with this
      // bar pinned over the target, so the offset has to be reserved either
      // way. Measured rather than hardcoded so a font swap or a reflow of
      // the nav's own text can't leave it stale.
      updateNavHeight() {
        const away = this.classList.contains('cns-nav--away');
        document.documentElement.style.setProperty(
          '--cns-sticky-navigation-height',
          `${away ? 0 : this.getBoundingClientRect().height}px`
        );
      }

      // Phone only: away after a clear scroll down past the bar's own
      // height, back on the first scroll up, near the top, when the page
      // width changes, or when keyboard focus lands inside the bar
      // (audit V157). An open panel freezes the state.
      watchScroll() {
        const phone = window.matchMedia('(max-width: 47.9375rem)');
        let lastY = window.scrollY;
        this.stopScrollWatch = window.cnsOnScrollFrame(() => {
          const y = window.scrollY;
          const delta = y - lastY;
          lastY = y;
          if (!phone.matches || !this.classList.contains('is-pinned')) {
            this.setAway(false);
            return;
          }
          if (document.querySelector('dialog[open]')) return;
          const height = this.getBoundingClientRect().height;
          if (delta > 8 && y > height * 2) this.setAway(true);
          else if (delta < -8 || y <= height) this.setAway(false);
        });
        this.addEventListener('focusin', () => this.setAway(false));

        // A same-page link to a point above (the buy bar's "Zmień") scrolls
        // up, which brings the bar back; with the bar away the anchor offset
        // was 0 for it, so the jump ended with the target under the
        // returning bar (owner, 2026-10-10: the option chips half hidden).
        // Bring it back before the browser works out the jump.
        this.handleAnchorClick = (event) => {
          const link = event.target.closest && event.target.closest('a[href^="#"]');
          if (!link || !this.classList.contains('cns-nav--away')) return;
          const id = decodeURIComponent(link.getAttribute('href').slice(1));
          const target = id && document.getElementById(id);
          if (target && target.getBoundingClientRect().top < 0) this.setAway(false);
        };
        document.addEventListener('click', this.handleAnchorClick, true);
      }

      setAway(away) {
        if (away === this.classList.contains('cns-nav--away')) return;
        this.classList.toggle('cns-nav--away', away);
        this.updateNavHeight();
      }

      handleOffsetChange(event) {
        this.intersectionObserver?.disconnect();
        // The guarantee bar sends its height with the event; reading the
        // property it has just written would force a style recalculation
        // (audit F222). Only the first call, without an event, reads it.
        const reported = event && event.detail ? event.detail.guaranteeHeight : undefined;
        const offset = typeof reported === 'number'
          ? reported
          : parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cns-guarantee-height')) || 0;
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.setPinned(!entry.isIntersecting);
        }, { rootMargin: `-${offset + 1}px 0px 0px 0px`, threshold: 0 });
        this.intersectionObserver.observe(this.sentinel);
      }

      setPinned(pinned) {
        if (pinned === this.classList.contains('is-pinned')) return;
        if (pinned) {
          // Measure the in-flow height before popping this out to `fixed`,
          // so the wrapper below can hold that much space in its place.
          if (this.section) this.section.style.height = `${this.getBoundingClientRect().height}px`;
          this.classList.add('is-pinned');
        } else {
          this.classList.remove('is-pinned');
          if (this.section) this.section.style.height = '';
        }
      }

      updateSpacer() {
        if (this.section && this.classList.contains('is-pinned')) {
          this.section.style.height = `${this.getBoundingClientRect().height}px`;
        }
      }

      disconnectedCallback() {
        if (this.stopScrollWatch) this.stopScrollWatch();
        if (this.handleAnchorClick) document.removeEventListener('click', this.handleAnchorClick, true);
        this.intersectionObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.sentinel?.remove();
        document.removeEventListener('cns:offset-change', this.handleOffsetChange);
        if (!document.querySelector('cns-sticky-nav')) {
          document.documentElement.style.setProperty('--cns-sticky-navigation-height', '0px');
        }
      }
    });
  }

  if (!window.__cnsNavInit) {
    window.__cnsNavInit = true;

    let lastFocusTarget = null;
    let hoverOpenTimer = null;
    let hoverCloseTimer = null;

    const getPanel = (id) => (id ? document.getElementById(id) : null);

    function closeDropdown(button, dropdown) {
      if (!button || !dropdown) return;
      delete dropdown.dataset.hoverOpened;
      button.setAttribute('aria-expanded', 'false');
      dropdown.classList.remove('is-open');
      window.setTimeout(() => {
        if (!dropdown.classList.contains('is-open')) dropdown.hidden = true;
      }, 150);
    }

    function closeAllDropdowns(except) {
      document.querySelectorAll('[data-cns-dropdown-trigger][aria-expanded="true"]').forEach((button) => {
        if (button === except) return;
        closeDropdown(button, getPanel(button.getAttribute('aria-controls')));
      });
    }

    function openDropdown(button, dropdown) {
      if (!button || !dropdown) return;
      closeAllDropdowns(button);
      button.setAttribute('aria-expanded', 'true');
      dropdown.hidden = false;
      requestAnimationFrame(() => dropdown.classList.add('is-open'));
    }

    function openPanel(dialog, trigger) {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      document.querySelectorAll('dialog.cns-panel[open]').forEach((open) => {
        if (open !== dialog) open.close();
      });
      lastFocusTarget = trigger || document.activeElement;
      if (!dialog.open) dialog.showModal();
      // The search field keeps the last query; selecting it lets typing
      // replace it instead of prepending to it (audit V028).
      const field = dialog.querySelector('input[type="search"]');
      if (field) {
        field.focus();
        field.select();
      }
    }

    function closePanel(dialog) {
      if (dialog && dialog.open) dialog.close();
    }

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-cns-open]');
      if (opener) {
        // Ctrl/Cmd/Shift/middle click keeps the icon a link, opening /cart or
        // /search in a new tab, as panel-frame.liquid's triggers do (audit H048).
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const dialog = getPanel(opener.getAttribute('aria-controls'));
        if (dialog) {
          event.preventDefault();
          openPanel(dialog, opener);
        }
        return;
      }

      const closer = event.target.closest('[data-cns-close]');
      if (closer) {
        closePanel(closer.closest('dialog.cns-panel'));
        return;
      }

      const disclosure = event.target.closest('[data-cns-dropdown-trigger]');
      if (disclosure) {
        const dropdown = getPanel(disclosure.getAttribute('aria-controls'));
        // A hover timer still running would reopen the list right after this
        // click and mark it hover-opened again (audit H019).
        window.clearTimeout(hoverOpenTimer);
        const isOpen = disclosure.getAttribute('aria-expanded') === 'true';
        // A list the pointer just opened by hovering stays open on the click
        // that usually follows; the next click closes it (audit V012).
        if (isOpen && dropdown && dropdown.dataset.hoverOpened) {
          delete dropdown.dataset.hoverOpened;
        } else if (isOpen) {
          closeDropdown(disclosure, dropdown);
        } else {
          openDropdown(disclosure, dropdown);
        }
        return;
      }

      if (!event.target.closest('.cns-nav__link-group')) {
        closeAllDropdowns();
      }

      if (event.target.matches('dialog.cns-panel[open]')) {
        closePanel(event.target);
      }
    });

    // Anything that changes the cart in place (product-buy-form.liquid
    // adding a product, cart-line.liquid changing a quantity) sends the
    // freshly rendered sections here. Only the parts that draw the cart are
    // swapped in: the panel's contents, the bag icon with its count and,
    // on /cart, that page's own body. Focus returns to the control that was
    // in use, which the swap would otherwise drop. An add also opens the
    // panel and shows its "Dodano do koszyka" line.
    let addedNoteTimer = null;

    function hideAddedNote(dialog) {
      const note = dialog.querySelector('[data-cart-added]');
      if (!note || note.hidden) return;
      note.classList.add('is-leaving');
      const done = () => {
        note.hidden = true;
        note.classList.remove('is-leaving');
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
      else window.setTimeout(done, 300);
    }

    document.addEventListener('cns:cart-refresh', (event) => {
      const detail = event.detail || {};
      const dialog = getPanel('cns-cart-panel');
      const active = document.activeElement;
      const focusKey = active && active.dataset ? active.dataset.cartFocus : null;
      // The panel and the /cart page carry the same controls; focus goes
      // back to the copy that was in use, not to its twin in a closed panel.
      const focusScope = active && active.closest && active.closest('.cns-cart') ? '.cns-cart' : '#cns-cart-panel';

      Object.values(detail.sections || {}).forEach((html) => {
        if (!html) return;
        const fresh = new DOMParser().parseFromString(html, 'text/html');
        // DOMParser parses with scripting off, so <noscript> content turns
        // into live elements: the delivery choice's no-JS style would hide
        // the locker option and the /cart "Aktualizuj" button would show.
        fresh.querySelectorAll('noscript').forEach((node) => node.remove());
        ['#cns-cart-panel .cns-panel__box', '.cns-nav__action--cart', '.cns-cart__inner'].forEach((selector) => {
          const current = document.querySelector(selector);
          const next = fresh.querySelector(selector);
          if (current && next) current.replaceWith(next);
        });
      });

      announceCart(detail.added);

      if (detail.added && dialog) {
        const note = dialog.querySelector('[data-cart-added]');
        if (note) note.hidden = false;
        // The note is for the moment of adding: it folds away after 5 s
        // (owner, 2026-10-14). The panel's contents may be redrawn meanwhile,
        // so the note is looked up again when the time is up.
        window.clearTimeout(addedNoteTimer);
        addedNoteTimer = window.setTimeout(() => hideAddedNote(dialog), 5000);
        openPanel(dialog, detail.trigger);
        return;
      }

      if (focusKey) {
        const scope = document.querySelector(focusScope);
        // The control in use is gone with its line ("Usuń", a quantity at
        // 0): focus moves to the first line left, or to the panel's close
        // button / the page's heading, never to <body> (audit F186). On that
        // line it takes the quantity field, not "Usuń": a second Enter would
        // remove another product (audit H016).
        let again = document.querySelector(`${focusScope} [data-cart-focus="${focusKey}"]`);
        if (!again && scope) again = scope.querySelector('[data-cart-quantity]') || scope.querySelector('[data-cart-focus]:not([data-cart-remove])');
        if (!again && scope) again = scope.querySelector(focusScope === '.cns-cart' ? '.cns-cart__title' : '.cns-panel__close');
        if (again) {
          if (again.matches('h1, h2')) again.setAttribute('tabindex', '-1');
          again.focus();
        }
      }
    });

    // Says what the cart now holds, in the region the shopper can hear: the
    // panel's own while it is open, the page's otherwise. Cleared first and
    // written a moment later, so the same sentence twice is read twice.
    function announceCart(added) {
      const page = document.querySelector('[data-cart-live]');
      if (!page) return;
      const panel = getPanel('cns-cart-panel');
      const inPanel = panel && (panel.open || added);
      const region = inPanel ? panel.querySelector('[data-cart-live-panel]') : page;
      if (!region) return;
      const totalEl = document.querySelector('#cns-cart-panel [data-cart-total]');
      const text = totalEl
        ? (added ? page.dataset.addedText : page.dataset.updatedText).replace('__TOTAL__', totalEl.dataset.cartTotal)
        : page.dataset.emptyText;
      region.textContent = '';
      window.setTimeout(() => { region.textContent = text; }, 150);
    }

    document.addEventListener('close', (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('cns-panel')) return;
      // A panel opened again from the bag icon starts without the note.
      window.clearTimeout(addedNoteTimer);
      const addedNote = dialog.querySelector('[data-cart-added]');
      if (addedNote) {
        addedNote.hidden = true;
        addedNote.classList.remove('is-leaving');
      }
      // The control that opened the panel may be gone (the bag icon is
      // redrawn on every cart change) or hidden (a closed quick-buy dialog):
      // focus then goes to the panel's own opener, never to <body> (audit H015).
      let back = lastFocusTarget;
      const usable = (el) => el && el.isConnected && typeof el.focus === 'function' && el.getClientRects().length > 0;
      if (!usable(back)) back = document.querySelector('[data-cns-open][aria-controls="' + dialog.id + '"]');
      if (usable(back)) back.focus();
      lastFocusTarget = null;
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      // In the search panel the first Escape closes the panel; left to the
      // browser it would only clear the field (audit V037).
      const searchPanel = event.target.closest && event.target.closest('#cns-search-panel');
      if (searchPanel) {
        event.preventDefault();
        closePanel(searchPanel);
        return;
      }
      // Focus inside an open list would be left on a link that is about to
      // hide: it goes back to the button that opened the list (audit F182).
      const group = document.activeElement && document.activeElement.closest('.cns-nav__link-group');
      const trigger = group && group.querySelector('[data-cns-dropdown-trigger][aria-expanded="true"]');
      closeAllDropdowns();
      if (trigger && document.activeElement !== trigger) trigger.focus();
    });

    // Tabbing out of the kits list closes it, as moving the mouse away does.
    document.addEventListener('focusout', (event) => {
      const group = event.target.closest && event.target.closest('.cns-nav__link-group');
      if (!group || (event.relatedTarget && group.contains(event.relatedTarget))) return;
      const trigger = group.querySelector('[data-cns-dropdown-trigger][aria-expanded="true"]');
      if (trigger) closeDropdown(trigger, getPanel(trigger.getAttribute('aria-controls')));
    });

    document.addEventListener('mouseover', (event) => {
      // Mouse only: the mouseover a tap fires would mark the list
      // hover-opened and the next tap would not close it (audit H019).
      if (event.sourceCapabilities && event.sourceCapabilities.firesTouchEvents) return;
      if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;
      const group = event.target.closest('.cns-nav__link-group');
      if (!group) return;
      const disclosure = group.querySelector('[data-cns-dropdown-trigger]');
      const dropdown = disclosure && getPanel(disclosure.getAttribute('aria-controls'));
      if (!disclosure || !dropdown) return;
      window.clearTimeout(hoverCloseTimer);
      window.clearTimeout(hoverOpenTimer);
      hoverOpenTimer = window.setTimeout(() => {
        // Only a list this hover opens counts as hover-opened; moving over
        // a list already open leaves its state alone (audit H019).
        if (disclosure.getAttribute('aria-expanded') === 'true') return;
        openDropdown(disclosure, dropdown);
        dropdown.dataset.hoverOpened = '1';
      }, 350);
    });

    // Theme editor: a selected kit link shows inside its open list or menu
    // panel, which are otherwise hidden (audit H029).
    document.addEventListener('shopify:block:select', (event) => {
      const dropdown = event.target.closest && event.target.closest('.cns-nav__dropdown');
      if (dropdown) {
        openDropdown(document.querySelector(`[aria-controls="${dropdown.id}"]`), dropdown);
        return;
      }
      const panel = event.target.closest && event.target.closest('dialog.cns-panel');
      if (panel) openPanel(panel, null);
    });
    document.addEventListener('shopify:block:deselect', () => {
      closeAllDropdowns();
    });

    document.addEventListener('mouseout', (event) => {
      const group = event.target.closest('.cns-nav__link-group');
      if (!group) return;
      if (event.relatedTarget && group.contains(event.relatedTarget)) return;
      window.clearTimeout(hoverOpenTimer);
      const disclosure = group.querySelector('[data-cns-dropdown-trigger]');
      const dropdown = disclosure && getPanel(disclosure.getAttribute('aria-controls'));
      if (!disclosure || !dropdown) return;
      hoverCloseTimer = window.setTimeout(() => closeDropdown(disclosure, dropdown), 200);
    });
  }

  // ---- cart lines (markup in snippets/cart-line.liquid) ----
  // Kept here rather than in the snippet: a snippet's script is loaded only
  // on pages where the snippet rendered at page load, and the cart panel
  // starts empty for every new visitor, so the lines swapped in after the
  // first "Dodaj do koszyka" would have no script to serve their −/+, "Usuń"
  // and per-component "Usuń".
  (function () {
    // The sections that draw the cart on this page: always the header (its
    // panel and bag icon), plus the /cart page's own section when it is the
    // page being viewed. Asking for them with the change itself means one
    // round trip brings back the saved cart already rendered.
    function cartSectionIds() {
      var ids = [];
      ['#cns-cart-panel', '.cns-cart'].forEach(function (selector) {
        var el = document.querySelector(selector);
        var section = el && el.closest('.shopify-section');
        if (section) ids.push(section.id.replace('shopify-section-', ''));
      });
      return ids;
    }

    function postJson(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (response) {
        // A refusal can come back as an HTML page (a rate limit): no body
        // to read, still a refusal.
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) throw new Error('cart request refused');
          return data;
        });
      });
    }

    // One cart request at a time, in the order they were asked for: two
    // quick changes on different lines can no longer answer out of order and
    // leave the panel showing the older of the two states (audit F178).
    var queue = Promise.resolve();
    function enqueue(task) {
      var run = queue.then(task, task);
      queue = run.catch(function () {});
      return run;
    }
    // The delivery choice and the consents save through the same queue, so a
    // quantity change right after them cannot redraw the cart from before
    // their save (audit H049).
    window.cnsCartQueue = enqueue;

    // After a failure the cart is drawn again from what the server holds: a
    // change can go through while its answer is lost, so the page's last
    // drawing may no longer be true
    // (audit G008). Rejects when even this request fails (no connection).
    function refreshCart() {
      // Never from the HTTP cache: a stored copy of these sections would draw
      // the cart as it was before the change.
      var url = window.location.pathname + '?sections=' + encodeURIComponent(cartSectionIds().join(',')) + '&_=' + Date.now();
      return fetch(url, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart refresh refused');
          return response.json();
        })
        .then(function (sections) {
          document.dispatchEvent(new CustomEvent('cns:cart-refresh', { detail: { sections: sections } }));
        });
    }

    // Always the shop's own sentence: what Shopify or the browser say
    // ("Cannot find variant", "Failed to fetch") is English and technical
    // (audit F177). It goes on the copy of the line that is on screen now;
    // a line that is gone after the refresh (the change did go through)
    // needs no message.
    function showLineError(line) {
      var errorEl = line.querySelector('[data-cart-line-error]');
      if (!errorEl) return;
      errorEl.textContent = line.dataset.cartErrorText;
      errorEl.hidden = false;
    }

    // What identifies a line beyond its key, taken when it is clicked: a
    // line's key changes whenever Shopify recalculates its discounts, so a
    // queued request looks the line up again in the cart as it is drawn by
    // then.
    function lineRef(line) {
      return {
        key: line.dataset.cartLine,
        variant: line.dataset.cartVariant,
        scope: line.closest('.cns-cart') ? '.cns-cart' : '#cns-cart-panel',
      };
    }

    function findLine(ref) {
      var scope = document.querySelector(ref.scope);
      if (!scope) return null;
      var same = scope.querySelector('[data-cart-line="' + CSS.escape(ref.key) + '"]');
      if (same) return same;
      return Array.prototype.filter.call(scope.querySelectorAll('[data-cart-line]'), function (candidate) {
        return candidate.dataset.cartVariant === ref.variant;
      })[0] || null;
    }

    function recover(line, ref) {
      ref = ref || lineRef(line);
      return refreshCart().then(
        function () {
          var fresh = findLine(ref);
          if (fresh) showLineError(fresh);
        },
        function () {
          // Not even the refresh went through: the line stays as drawn,
          // with its number back and the message under it.
          line.removeAttribute('aria-busy');
          var input = line.querySelector('[data-cart-quantity]');
          if (input) input.value = input.defaultValue;
          showLineError(line);
        }
      );
    }

    function setQuantity(line, quantity) {
      if (line.getAttribute('aria-busy') === 'true') return;
      var errorEl = line.querySelector('[data-cart-line-error]');
      if (errorEl) errorEl.hidden = true;
      line.setAttribute('aria-busy', 'true');
      var ref = lineRef(line);

      enqueue(function () {
        var target = findLine(ref) || line;
        return postJson(line.dataset.cartChangeUrl + '.js', {
          id: target.dataset.cartLine,
          quantity: quantity,
          sections: cartSectionIds(),
          sections_url: window.location.pathname,
        })
          .then(function (data) {
            if (!data.sections) throw new Error('cart change refused');
            document.dispatchEvent(new CustomEvent('cns:cart-refresh', { detail: { sections: data.sections } }));
          })
          .catch(function () {
            return recover(line, ref);
          });
      });
    }

    document.addEventListener('click', function (event) {
      var step = event.target.closest('[data-cart-step]');
      var remove = event.target.closest('[data-cart-remove]');
      if (!step && !remove) return;
      var line = event.target.closest('[data-cart-line]');
      if (!line) return;
      event.preventDefault();
      if (remove) {
        setQuantity(line, 0);
        return;
      }
      // A line still saving keeps its number: a second press would show a
      // count nobody saves (audit H047).
      if (line.getAttribute('aria-busy') === 'true') return;
      var input = line.querySelector('[data-cart-quantity]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.cartStep));
      input.value = next;
      setQuantity(line, next);
    });

    // Enter in a quantity field saves it in place, like leaving the field,
    // instead of submitting the /cart form, whose default button is
    // checkout (audit H001).
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var input = event.target.closest && event.target.closest('[data-cart-quantity]');
      if (!input) return;
      event.preventDefault();
      input.blur();
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      var line = input.closest('[data-cart-line]');
      if (!line) return;
      // An emptied field is no change: removing takes "Usuń" or a typed 0
      // (audit H020).
      var typed = parseInt(input.value, 10);
      if (input.value.trim() === '' || !isFinite(typed)) {
        input.value = input.defaultValue;
        return;
      }
      setQuantity(line, Math.max(0, typed));
    });
  })();

  // The cart list's fade (see .cns-cart-panel__footer::before): on while the
  // list has more below what shows. Checked when the list scrolls, when the
  // panel opens or its markup is swapped after a change, and on resize.
  // The panel is looked up on each call: the theme editor can redraw the
  // header and leave an old reference behind (audit H050).
  (function () {
    if (!document.getElementById('cns-cart-panel')) return;
    function update() {
      var panel = document.getElementById('cns-cart-panel');
      if (!panel) return;
      var body = panel.querySelector('.cns-panel__body');
      if (!body) return;
      var more = body.scrollTop + body.clientHeight < body.scrollHeight - 4;
      var box = panel.querySelector('.cns-panel__box');
      if (box) box.toggleAttribute('data-more', more);
    }
    document.addEventListener('scroll', function (event) {
      if (event.target && event.target.closest && event.target.closest('#cns-cart-panel')) update();
    }, true);
    var observer = new MutationObserver(function () { window.requestAnimationFrame(update); });
    function watch() {
      var panel = document.getElementById('cns-cart-panel');
      observer.disconnect();
      if (panel) observer.observe(panel, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
    }
    watch();
    document.addEventListener('shopify:section:load', watch);
    window.addEventListener('resize', update);
  })();

  // The cart's delivery choice (cart-delivery-choice.liquid), in the panel
  // and on the /cart page. Each change is saved to the cart at once, so a
  // re-render of the panel keeps it, and mirrored into the other view; the
  // locker part shows only with the locker picked. With a map token the
  // locker is picked on InPost's Geowidget in a dialog (its script loads on
  // the first open), which opens as soon as the locker is chosen and shows
  // the point by its address; closing it without a point goes back to the
  // courier. Without a token, a code is typed.
  // The checkout button waits for a method and, for the locker, a point
  // (or a code in InPost's form: three letters, two to four digits, maybe
  // letters: KRA01M, WAW123A). PaczkoPunkty in shops (codes POP-…) are
  // refused: Herbalife's warehouse ships to Paczkomaty only (2026-10-12).
  (function () {
    if (window.__cnsDeliveryChoice) return;
    window.__cnsDeliveryChoice = true;
    var LOCKER = 'Paczkomat InPost';
    var CODE = /^[A-Z]{3}[0-9]{2,4}[A-Z]{0,4}$/;
    var SHOP_POINT = /^POP-/;
    var POINT_EVENT = 'cns-inpost-point';
    var saveTimer = null;
    var mapScript = null;

    function save(attributes) {
      var run = function () {
        return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).catch(function () {});
      };
      if (window.cnsCartQueue) window.cnsCartQueue(run);
      else run();
    }

    function chosen(box) {
      var picked = box.querySelector('[data-delivery-method]:checked');
      return picked ? picked.value : '';
    }

    function showError(box, message) {
      var error = box.querySelector('[data-delivery-error]');
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
    }

    // Copies the method and, when given, the code and the point's address
    // into every view on the page.
    function sync(method, code, address) {
      document.querySelectorAll('[data-delivery]').forEach(function (box) {
        box.querySelectorAll('[data-delivery-method]').forEach(function (radio) {
          radio.checked = radio.value === method;
        });
        var codeField = box.querySelector('[data-delivery-code]');
        if (codeField && code !== undefined && codeField.value !== code) codeField.value = code;
        var addressField = box.querySelector('[data-delivery-address]');
        if (addressField && address !== undefined) addressField.value = address;
        var point = box.querySelector('[data-delivery-point]');
        if (point && code !== undefined) {
          point.hidden = !code;
          var text = point.querySelector('[data-delivery-point-text]');
          if (text) text.textContent = address || code;
        }
        // With the map, the locker part shows only once a point is picked:
        // an empty one would take the gap and jump the cart's footer.
        var locker = box.querySelector('[data-delivery-locker]');
        var withMap = !!box.parentNode.querySelector('[data-delivery-map]');
        var hasCode = !!(box.querySelector('[data-delivery-code]') || {}).value;
        if (locker) locker.hidden = method !== LOCKER || (withMap && !hasCode);
        showError(box, '');
      });
    }

    function currentCode(box) {
      var field = box.querySelector('[data-delivery-code]');
      return field ? field.value.trim().toUpperCase() : '';
    }

    function showMapError() {
      document.querySelectorAll('[data-delivery-map-slot]').forEach(function (slot) {
        slot.innerHTML = '';
        var message = document.createElement('p');
        message.className = 'cns-map-dialog__message';
        message.textContent = slot.closest('[data-delivery-map]').dataset.mapError;
        slot.appendChild(message);
      });
    }

    function showShopPointNotice(dialog, show) {
      var notice = dialog.querySelector('[data-delivery-map-notice]');
      if (notice) notice.hidden = !show;
    }

    function openMap(dialog) {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var slot = dialog.querySelector('[data-delivery-map-slot]');
      if (slot && !slot.querySelector('inpost-geowidget')) {
        slot.innerHTML = '';
        if (!mapScript) {
          var css = document.createElement('link');
          css.rel = 'stylesheet';
          css.href = 'https://geowidget.inpost.pl/inpost-geowidget.css';
          document.head.appendChild(css);
          mapScript = document.createElement('script');
          mapScript.src = 'https://geowidget.inpost.pl/inpost-geowidget.js';
          mapScript.defer = true;
          mapScript.onerror = function () {
            mapScript = null;
            showMapError();
          };
          document.head.appendChild(mapScript);
        }
        var widget = document.createElement('inpost-geowidget');
        // The map opens on Paczkomaty instead of "Wszystkie": the warehouse
        // ships to no other kind of point. The widget hands its API over in
        // this event, so the listener goes on before the element is added.
        widget.addEventListener('inpost.geowidget.init', function (event) {
          try {
            var api = event.detail && event.detail.api;
            if (api && typeof api.changePointsType === 'function') api.changePointsType('PARCEL_LOCKER');
          } catch (error) {}
        });
        widget.setAttribute('token', dialog.dataset.token);
        widget.setAttribute('language', 'pl');
        widget.setAttribute('config', 'parcelcollect');
        widget.setAttribute('onpoint', POINT_EVENT);
        slot.appendChild(widget);
      }
      showShopPointNotice(dialog, false);
      var chosenBar = dialog.querySelector('[data-delivery-map-chosen]');
      if (chosenBar) chosenBar.hidden = true;
      dialog.classList.remove('is-closing');
      dialog.showModal();
    }

    // Closing the map fades it out (200 ms) instead of cutting it off, so
    // it does not seem to vanish. After a pick the confirmation shows for
    // 400 ms first and the picked point on the page lights up once the map
    // is gone. With reduced motion it closes at once.
    var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function highlightPoint() {
      document.querySelectorAll('[data-delivery-point]:not([hidden])').forEach(function (point) {
        point.classList.remove('is-just-picked');
        void point.offsetWidth;
        point.classList.add('is-just-picked');
      });
    }

    function closeMap(dialog, chosenText) {
      if (!dialog || !dialog.open || dialog.dataset.closing) return;
      if (reducedMotion && reducedMotion.matches) {
        dialog.close();
        return;
      }
      dialog.dataset.closing = 'true';
      var fade = function () {
        dialog.classList.add('is-closing');
        setTimeout(function () {
          dialog.close();
          dialog.classList.remove('is-closing');
          delete dialog.dataset.closing;
          if (chosenText) highlightPoint();
        }, 200);
      };
      var chosenBar = dialog.querySelector('[data-delivery-map-chosen]');
      if (chosenText && chosenBar) {
        chosenBar.querySelector('[data-delivery-map-chosen-text]').textContent = chosenText;
        chosenBar.hidden = false;
        setTimeout(fade, 400);
      } else {
        fade();
      }
    }

    // InPost's widget announces the picked point with the event named in
    // its "onpoint" attribute. Its location description follows the
    // browser's language (an English browser got "At the entrance to the
    // property…" despite language="pl"), so the Polish one comes from
    // InPost's public points API, asked in Polish (it too answers in the
    // browser's language otherwise); without an answer in 3 s the label
    // is the address alone.
    function polishDescription(code) {
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = setTimeout(function () {
        if (controller) controller.abort();
      }, 3000);
      return fetch('https://api-pl-points.easypack24.net/v1/points/' + encodeURIComponent(code), {
        headers: { 'Accept-Language': 'pl' },
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          return response.ok ? response.json() : {};
        })
        .then(function (data) {
          return String(data.location_description || '').trim();
        })
        .catch(function () {
          return '';
        })
        .finally(function () {
          clearTimeout(timer);
        });
    }

    document.addEventListener(POINT_EVENT, function (event) {
      var point = event.detail || event.details || {};
      var code = String(point.name || '').toUpperCase();
      if (!code) return;
      // A PaczkoPunkt: the map stays open with the reason, nothing saved.
      if (SHOP_POINT.test(code)) {
        document.querySelectorAll('[data-delivery-map][open]').forEach(function (dialog) {
          showShopPointNotice(dialog, true);
        });
        return;
      }
      var address = point.address || {};
      var place = [address.line1, address.line2].filter(Boolean).join(', ');
      document.querySelectorAll('[data-delivery-map][open]').forEach(function (dialog) {
        var chosenText = (dialog.dataset.mapChosen || '').replace('%code%', code) + (place ? ' – ' + place : '');
        closeMap(dialog, chosenText);
      });
      sync(LOCKER, code, place || code);
      save({ 'Dostawa': LOCKER, 'Paczkomat': code, 'Paczkomat adres': place || code });
      polishDescription(code).then(function (description) {
        // A point picked again meanwhile wins.
        var field = document.querySelector('[data-delivery-code]');
        if (!description || (field && field.value !== code)) return;
        var label = (place ? place + ' · ' : '') + description;
        sync(LOCKER, code, label);
        save({ 'Paczkomat adres': label });
      });
    });

    document.addEventListener('click', function (event) {
      var opener = event.target.closest && event.target.closest('[data-delivery-map-open]');
      if (opener) {
        event.preventDefault();
        openMap(document.getElementById(opener.dataset.deliveryMapOpen));
        return;
      }
      var closer = event.target.closest && event.target.closest('[data-delivery-map-close]');
      if (closer) {
        closeMap(closer.closest('dialog'));
        return;
      }
      if (event.target.matches && event.target.matches('dialog[data-delivery-map]')) {
        closeMap(event.target);
      }
    });

    // Esc fades the map out like the close button does.
    document.addEventListener('cancel', function (event) {
      var dialog = event.target;
      if (!dialog.matches || !dialog.matches('[data-delivery-map]')) return;
      if (reducedMotion && reducedMotion.matches) return;
      event.preventDefault();
      closeMap(dialog);
    }, true);

    // The map closed without a point while the locker is chosen: back to
    // the courier, so no order leaves with a locker but no point.
    document.addEventListener('close', function (event) {
      var dialog = event.target;
      if (!dialog.matches || !dialog.matches('[data-delivery-map]')) return;
      var box = dialog.parentNode.querySelector('[data-delivery]');
      if (!box || chosen(box) !== LOCKER || currentCode(box)) return;
      var courier = box.querySelector('[data-delivery-method]:not([value="' + LOCKER + '"])');
      if (!courier) return;
      sync(courier.value, '', '');
      save({ 'Dostawa': courier.value, 'Paczkomat': '', 'Paczkomat adres': '' });
    }, true);

    document.addEventListener('change', function (event) {
      var radio = event.target.closest && event.target.closest('[data-delivery-method]');
      if (!radio) return;
      var box = radio.closest('[data-delivery]');
      var code = currentCode(box);
      sync(radio.value);
      var attributes = { 'Dostawa': radio.value };
      if (radio.value !== LOCKER) {
        attributes['Paczkomat'] = '';
        attributes['Paczkomat adres'] = '';
      } else {
        attributes['Paczkomat'] = code;
        var addressField = box.querySelector('[data-delivery-address]');
        if (addressField) attributes['Paczkomat adres'] = addressField.value;
      }
      save(attributes);
      if (radio.value === LOCKER && !code) {
        var map = box.parentNode.querySelector('[data-delivery-map]');
        var typed = box.querySelector('input[type="text"][data-delivery-code]');
        if (map) openMap(map);
        else if (typed) typed.focus();
      }
    });

    // The typed code (no map token).
    document.addEventListener('input', function (event) {
      var field = event.target.closest && event.target.closest('input[type="text"][data-delivery-code]');
      if (!field) return;
      var box = field.closest('[data-delivery]');
      sync(chosen(box), field.value);
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        save({ 'Paczkomat': field.value.trim().toUpperCase() });
      }, 400);
    });

    // A checkout form with the choice in it goes on only when it is
    // complete; a typed code is sent upper case.
    document.addEventListener('submit', function (event) {
      var form = event.target;
      var box = form.querySelector && form.querySelector('[data-delivery]');
      if (!box || !event.submitter || event.submitter.name !== 'checkout') return;
      var method = chosen(box);
      if (!method) {
        event.preventDefault();
        showError(box, box.dataset.chooseError);
        box.querySelector('[data-delivery-method]').focus();
        return;
      }
      if (method !== LOCKER) return;
      var typed = box.querySelector('input[type="text"][data-delivery-code]');
      if (typed) {
        typed.value = typed.value.trim().toUpperCase();
        if (!CODE.test(typed.value)) {
          event.preventDefault();
          showError(box, box.dataset.codeError);
          typed.focus();
        }
      } else if (!currentCode(box)) {
        event.preventDefault();
        showError(box, box.dataset.pickError);
        var map = box.parentNode.querySelector('[data-delivery-map]');
        if (map) openMap(map);
      }
    });
  })();

  // The cart's e-mail consents (snippets/cart-consents.liquid): kept here
  // because the snippet's own script would be missing on a page whose cart
  // panel started empty.
  (function () {
    if (window.__cnsCartConsents) return;
    window.__cnsCartConsents = true;

    // Saves a tick the moment it changes, so a drawer re-render (after a
    // quantity change) does not drop it, and keeps the twin box in the
    // other cart view in step.
    document.addEventListener('change', function (event) {
      var box = event.target.closest && event.target.closest('[data-cart-consent]');
      if (!box) return;
      var key = box.dataset.cartConsent;
      document.querySelectorAll('[data-cart-consent]').forEach(function (other) {
        if (other !== box && other.dataset.cartConsent === key) other.checked = box.checked;
      });
      var attributes = {};
      attributes[key] = box.checked ? 'tak' : '';
      var run = function () {
        return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).catch(function () {});
      };
      // Same queue as quantity changes (audit H049).
      if (window.cnsCartQueue) window.cnsCartQueue(run);
      else run();
    });

    // "Szczegóły" opens the consent card; its X, a click on the dimmed
    // page around it and Esc (native to a modal dialog) close it.
    document.addEventListener('click', function (event) {
      var opener = event.target.closest && event.target.closest('[data-consent-open]');
      if (opener) {
        var dialog = document.getElementById(opener.dataset.consentOpen);
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          dialog.showModal();
        }
        return;
      }
      var closer = event.target.closest && event.target.closest('[data-consent-close]');
      if (closer) {
        closer.closest('dialog').close();
        return;
      }
      if (event.target.classList && event.target.classList.contains('cns-consent-dialog')) {
        event.target.close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-picker"] && !Shopify.designMode) return;
  try {
    
  // Narrows the kit cards to the answers given. A card fits an answer when
  // the answer is "any" or is among the values the card carries. When no
  // card fits all three, the nearest kit shows completed: first the kits
  // that fit the base and the goal, each with its Formuła 3 strip; failing
  // that, the kits that fit the base and the protein, each with the strip
  // for the goal asked for. Nothing is stored anywhere. Runs again for a
  // picker the theme editor re-renders (audit F004).
  (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-kit-picker]').forEach((root) => {
        if (root.dataset.cnsReady) return;
        root.dataset.cnsReady = '1';
        const form = root.querySelector('[data-picker-form]');
        const items = Array.from(root.querySelectorAll('[data-picker-item]'));
        if (!form || !items.length) return;

        const notes = {};
        root.querySelectorAll('[data-picker-note]').forEach((note) => {
          notes[note.dataset.pickerNote] = note;
        });
        const headings = {};
        root.querySelectorAll('[data-picker-heading]').forEach((heading) => {
          headings[heading.dataset.pickerHeading] = heading;
        });
        const reset = root.querySelector('[data-picker-reset]');
        const countRow = root.querySelector('[data-picker-count]');
        const countText = root.querySelector('[data-picker-count-text]');
        let answered = false;
        let lastAnswered = '';

        // Polish plural: 1 zestaw, 2–4 zestawy, 5+ zestawów (and 12–14).
        const countLabel = (n) => {
          const d = countRow.dataset;
          if (n === 0) return d.countNone;
          if (n === 1) return d.countOne;
          const few = n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14);
          return (few ? d.countFew : d.countMany).replace('__N__', n);
        };

        const answer = (name) => {
          const checked = form.querySelector(`input[name="${name}"]:checked`);
          return checked ? checked.value : 'any';
        };
        const fits = (item, key, value) => value === 'any' || (item.dataset[key] || '').split(',').includes(value);

        const update = () => {
          const base = answer('base');
          const protein = answer('protein');
          const goal = answer('goal');
          const untouched = base === 'any' && protein === 'any' && goal === 'any';

          const shown = new Map();
          const activeNotes = new Set();
          const exact = items.filter((item) => fits(item, 'base', base) && fits(item, 'protein', protein) && fits(item, 'goal', goal));

          if (exact.length) {
            exact.forEach((item) => shown.set(item, null));
          } else {
            const withoutProtein = items.filter((item) => fits(item, 'base', base) && fits(item, 'goal', goal));
            const withoutGoal = items.filter((item) => fits(item, 'base', base) && fits(item, 'protein', protein));
            if (withoutProtein.length) {
              withoutProtein.forEach((item) => shown.set(item, 'protein'));
              activeNotes.add('protein');
            } else if (withoutGoal.length) {
              withoutGoal.forEach((item) => shown.set(item, `goal-${goal}`));
              activeNotes.add('goal');
            } else {
              activeNotes.add('none');
            }
          }
          if (untouched) activeNotes.add('all');

          let combos = false;
          items.forEach((item) => {
            item.hidden = !shown.has(item);
            const combo = shown.get(item) || null;
            let visible = false;
            item.querySelectorAll('[data-combo]').forEach((strip) => {
              const match = combo !== null && strip.dataset.combo === combo;
              strip.hidden = !match;
              if (match) visible = true;
            });
            item.classList.toggle('cns-picker__item--combo', visible);
            if (visible) combos = true;
          });
          Object.entries(notes).forEach(([key, note]) => {
            note.hidden = !activeNotes.has(key);
          });
          if (headings.all) headings.all.hidden = !untouched;
          if (headings.filtered) headings.filtered.hidden = untouched || combos;
          if (headings.combo) headings.combo.hidden = !combos;
          if (reset) reset.hidden = untouched;

          // Only after an answer: the first draw of the page says nothing.
          if (countRow && countText && answered) {
            const shownCount = items.filter((item) => !item.hidden).length;
            countRow.hidden = untouched;
            // Only kits that fit every answer count as a match; the nearest
            // ones shown otherwise get "Żaden zestaw nie pasuje…" (audit H023).
            countText.textContent = untouched ? '' : (exact.length ? countLabel(shownCount) : countRow.dataset.countNone);
            // Brings the row into view only once the last question is
            // answered: after the first or second answer the visitor still
            // has questions to read, and on a phone the row sits under
            // them, so scrolling to it would skip past question three.
            if (!untouched && lastAnswered === 'goal') {
              const rect = countRow.getBoundingClientRect();
              // Also when it sits in the bottom quarter of the screen, where the
              // cookie banner of a first visit lies (audit H055).
              if (rect.bottom > window.innerHeight * 0.75 || rect.top < 0) {
                const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                // Centred, not at the bottom edge, where the cookie banner of
                // a first visit covers it (audit H055).
                countRow.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
              }
            }
          }
        };

        form.addEventListener('change', (event) => {
          answered = true;
          lastAnswered = event.target && event.target.name;
          update();
        });
        if (reset) {
          reset.addEventListener('click', () => {
            form.reset();
            update();
            // Back to the heading and the first question, not to the
            // middle of the answered boxes; the section's scroll-margin
            // keeps it clear of the sticky nav.
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            root.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
          });
        }
        update();
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  // The article's table of contents. Runs again for a section the theme
  // editor re-renders, and drops the old listeners when it goes (audit F179).
  (function () {
    var rail = window.matchMedia('(min-width: 60rem)');

    var init = function (scope) {
      var toc = scope.querySelector('[data-article-toc]');
      if (!toc || toc.dataset.cnsReady) return;
      toc.dataset.cnsReady = '1';

      // In the rail (from 60rem) the list is always open; on a phone it
      // starts closed and closes again once a part is picked, so the text
      // the reader asked for is not pushed down by the list.
      // In the rail the summary is only a heading, so it also leaves the
      // tab order (audit F265).
      var summary = toc.querySelector('summary');
      var settle = function () {
        toc.open = rail.matches;
        if (!summary) return;
        if (rail.matches) summary.setAttribute('tabindex', '-1');
        else summary.removeAttribute('tabindex');
      };
      settle();
      rail.addEventListener('change', settle);
      toc.addEventListener('toggle', function () {
        if (rail.matches && !toc.open) toc.open = true;
      });
      toc.addEventListener('click', function (event) {
        if (!rail.matches && event.target.closest('a[href^="#"]')) toc.open = false;
      });

      // The current part: the heading that has reached the reading line
      // (the bottom of the sticky header); at the page's end, the last
      // heading on screen. Measured on scroll, one read per frame.
      var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]'));
      var heads = links.map(function (link) {
        var id = link.getAttribute('href').slice(1);
        try {
          id = decodeURIComponent(id);
        } catch (error) {
          // keep the raw id
        }
        return document.getElementById(id);
      });
      var current = null;

      var update = function () {
        var padding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop);
        var line = (isNaN(padding) ? 0 : padding) + 8;
        var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
        var best = -1;
        var bestTop = -Infinity;
        heads.forEach(function (head, index) {
          if (!head) return;
          var top = head.getBoundingClientRect().top;
          var reached = top <= line || (atBottom && top < window.innerHeight);
          if (reached && top > bestTop) {
            best = index;
            bestTop = top;
          }
        });
        var next = best === -1 ? null : links[best];
        if (next === current) return;
        if (current) current.removeAttribute('aria-current');
        if (next) next.setAttribute('aria-current', 'true');
        current = next;
      };

      var stopScrollWatch = window.cnsOnScrollFrame(update);

      toc.cnsCleanup = function () {
        rail.removeEventListener('change', settle);
        stopScrollWatch();
      };
    };

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var toc = event.target.querySelector('[data-article-toc]');
      if (toc && toc.cnsCleanup) toc.cnsCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bundle"]) return;
  try {
    
  // The "Szczegóły produktu" dialogs' per-variant blocks. Opening and
  // closing the dialogs is panel-frame.liquid's script; the section nav
  // and the phone buy bar run their own (section-nav.liquid,
  // sticky-buy-bar.liquid). Runs again for a section the theme editor
  // re-renders, and drops the old listener when it goes (audit F036).
  (function () {
    var init = function (scope) {
      var root = scope.querySelector('[data-bundle-root]');
      if (!root || root.dataset.cnsReady) return;
      root.dataset.cnsReady = '1';

      // A component's Skład / Wartości odżywcze carry one block per
      // component variant, tagged with the kit variants it serves as
      // "||"-joined option tuples (bundle-component-panel.liquid); the block
      // whose list holds the current tuple shows. Matching the whole tuple,
      // not a single value: "Cytrynowy" alone would light the women's and
      // the men's Formuła 2 blocks together (audit F243).
      var onVariantChange = function (event) {
        // An add-on's quick buy changed its own variant, not the kit's.
        if (event.detail && event.detail.scoped) return;
        var options = (event.detail && event.detail.options) || [];
        var current = options.join('|');
        root.querySelectorAll('[data-component-variant-value]').forEach(function (el) {
          var tags = el.dataset.componentVariantValue.split('||');
          el.hidden = tags.indexOf(current) === -1;
        });
      };
      document.addEventListener('cns:variant-change', onVariantChange);
      root.cnsCleanup = function () {
        document.removeEventListener('cns:variant-change', onVariantChange);
      };
    };

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-bundle-root]');
      if (root && root.cnsCleanup) root.cnsCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-print-guide"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-print-guide]');
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    var handles = (params.get('p') || '')
      .split(',')
      .map(function (handle) { return handle.trim(); })
      .filter(Boolean);
    var templates = {};
    root.querySelectorAll('template[data-print-product]').forEach(function (template) {
      templates[template.dataset.printProduct] = template;
    });
    var picked = handles.filter(function (handle, index) {
      return templates[handle] && handles.indexOf(handle) === index;
    });
    if (!picked.length) {
      root.querySelector('[data-print-empty]').hidden = false;
      return;
    }

    var show = function (selector) {
      var element = root.querySelector(selector);
      if (element) element.hidden = false;
      return element;
    };
    var waterHandle = root.dataset.waterHandle;
    var wantsMilk = false;
    var wantsMilkProtein = false;
    var wantsWater = false;
    var wantsFlavour = false;
    var hasKit = false;
    var shakeAlone = false;
    var kitComponents = [];

    picked.forEach(function (handle) {
      var data = templates[handle].dataset;
      if (data.kind !== 'kit') return;
      hasKit = true;
      kitComponents = kitComponents.concat((data.components || '').split(' '));
      if (data.route === 'water') {
        wantsWater = true;
      } else {
        wantsMilk = true;
        wantsFlavour = true;
        if (data.protein === 'true') wantsMilkProtein = true;
      }
      root.querySelector('[data-print-kits]').appendChild(templates[handle].content.cloneNode(true));
    });

    picked.forEach(function (handle) {
      var data = templates[handle].dataset;
      if (data.kind === 'shake') {
        shakeAlone = true;
        if (data.flavour === 'true') wantsFlavour = true;
      } else if (data.kind === 'product' && kitComponents.indexOf(handle) === -1) {
        root.querySelector('[data-print-usages]').appendChild(templates[handle].content.cloneNode(true));
      }
    });

    // A Formuła 1 on its own gets the milk steps, and the water steps too
    // when Protein Drink Mix is on the list, as its page shows both.
    if (shakeAlone) {
      wantsMilk = true;
      if (waterHandle && picked.indexOf(waterHandle) !== -1) wantsWater = true;
    }

    if (wantsMilk || wantsWater) {
      show('[data-print-shake]');
      show('[data-print-warning]');
      show('[data-print-contact-shake]');
      if (wantsMilk) show(wantsMilkProtein ? '[data-print-milk="protein"]' : '[data-print-milk="plain"]');
      if (wantsWater) show('[data-print-water]');
      if (wantsMilk && wantsWater) {
        root.querySelectorAll('[data-print-shake] [data-print-route-label]').forEach(function (label) {
          label.hidden = false;
        });
      }
    }
    if (wantsFlavour) show('[data-print-flavour]');
    if (hasKit) show('[data-print-kit-start]');

    show('[data-print-body]');
    var button = show('[data-print-button]');
    button.addEventListener('click', function () {
      window.print();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // The page's own behaviour: per-variant blocks and labels, the nutrition
  // column switch, the phone-only fold of the vitamin/mineral cards, the
  // preparation routes and the label parts (an accordion on a phone, all
  // open wider). The section nav and the phone buy bar run their own scripts
  // (section-nav.liquid, sticky-buy-bar.liquid), shared with the kit page.
  // Runs again for a section the theme editor re-renders, and drops the old
  // listeners when it goes (audit F036).
  (function () {
    var init = function (scope) {
      var root = scope.querySelector('[data-product-page]');
      if (!root || root.dataset.cnsReady) return;
      root.dataset.cnsReady = '1';

      var phone = window.matchMedia('(max-width: 47.9375rem)');
      var activeColumn = null;

      var setColumn = function (block, column) {
        if (!block || !block.querySelector('[data-nutrition-col="' + column + '"]')) return;
        block.dataset.activeCol = column;
        block.querySelectorAll('[data-col]').forEach(function (piece) {
          piece.toggleAttribute('data-col-off', piece.dataset.col !== String(column));
        });
        block.querySelectorAll('[data-nutrition-col]').forEach(function (option) {
          option.setAttribute('aria-pressed', option.dataset.nutritionCol === column ? 'true' : 'false');
        });
      };

      // A variant picked in the buy form (or through a gallery thumbnail).
      var showVariantBlocks = function (id) {
        root.querySelectorAll('[data-product-variant-ids]').forEach(function (el) {
          var show = el.dataset.productVariantIds.split(' ').indexOf(id) !== -1;
          el.hidden = !show;
          // The newly shown nutrition block keeps the column the shopper chose.
          if (show && activeColumn !== null && el.classList.contains('cns-nutri')) {
            setColumn(el, activeColumn);
          }
        });
      };

      // A variant whose own nutrition table is not in the page yet: the
      // section is rendered again for that variant and only its block is
      // taken over (audit F243). One request per variant, then it is kept.
      var fetched = {};
      var fetchNutrition = function (id) {
        var band = root.querySelector('.cns-product__band .cns-nutri[data-product-variant-ids]');
        var container = band ? band.parentElement : null;
        if (!container || fetched[id]) return;
        var hasOwn = Array.prototype.some.call(root.querySelectorAll('.cns-nutri[data-product-variant-ids]'), function (el) {
          return el.dataset.productVariantIds.split(' ').indexOf(id) !== -1;
        });
        if (hasOwn) return;
        fetched[id] = true;
        var url = root.dataset.productUrl + '?variant=' + id + '&section_id=' + root.dataset.sectionId;
        fetch(url, { headers: { Accept: 'text/html' } })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (html) {
            // No table this time: the next choice of this flavour asks again (audit H056).
            if (!html) {
              fetched[id] = false;
              return;
            }
            var fresh = new DOMParser().parseFromString(html, 'text/html');
            fresh.querySelectorAll('.cns-nutri[data-product-variant-ids]').forEach(function (block) {
              if (block.dataset.productVariantIds.split(' ').indexOf(id) === -1) return;
              if (document.getElementById(block.id)) return;
              container.appendChild(document.importNode(block, true));
            });
            syncNutritionToggles();
            showVariantBlocks(String(currentId));
          })
          .catch(function () {
            fetched[id] = false;
          });
      };

      var currentId = root.querySelector('.cns-nutri[data-product-variant-ids]:not([hidden])')
        ? root.querySelector('.cns-nutri[data-product-variant-ids]:not([hidden])').dataset.productVariantIds.split(' ')[0]
        : '';

      var onVariantChange = function (event) {
        var detail = event.detail || {};
        // A panel's form (a quick buy on this page) is not this product's choice.
        if (detail.scoped) return;
        var id = String(detail.variantId || '');
        var options = detail.options || [];
        currentId = id;

        showVariantBlocks(id);
        fetchNutrition(id);

        root.querySelectorAll('[data-product-option-value]').forEach(function (el) {
          el.textContent = options.join(' / ');
        });
      };
      document.addEventListener('cns:variant-change', onVariantChange);

      // Vitamin/mineral cards fold only on a phone; wider they are always
      // open, so their buttons report "expanded" and leave the tab order.
      var syncNutritionToggles = function () {
        root.querySelectorAll('[data-nutri-toggle]').forEach(function (toggle) {
          var rows = document.getElementById(toggle.getAttribute('aria-controls'));
          if (phone.matches) {
            toggle.removeAttribute('tabindex');
            toggle.setAttribute('aria-expanded', rows && !rows.hidden ? 'true' : 'false');
          } else {
            toggle.setAttribute('tabindex', '-1');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      };

      // Label parts: an accordion on a phone, one row open at most and all
      // closed to start with; wider every part is open, so — like the
      // nutrition cards — the buttons report "expanded" and leave the tab
      // order.
      var tabGroup = root.querySelector('[data-label-tabs]');
      var tabs = tabGroup ? Array.prototype.slice.call(tabGroup.querySelectorAll('[data-label-tab]')) : [];
      var panelOf = function (tab) {
        return document.getElementById(tab.getAttribute('aria-controls'));
      };
      var syncTabs = function () {
        tabs.forEach(function (tab) {
          var panel = panelOf(tab);
          if (!panel) return;
          if (phone.matches) {
            tab.removeAttribute('tabindex');
            tab.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
          } else {
            tab.setAttribute('tabindex', '-1');
            tab.setAttribute('aria-expanded', 'true');
          }
        });
      };

      var syncMode = function () {
        syncNutritionToggles();
        syncTabs();
      };
      syncMode();
      if (phone.addEventListener) phone.addEventListener('change', syncMode);

      root.cnsCleanup = function () {
        document.removeEventListener('cns:variant-change', onVariantChange);
        if (phone.removeEventListener) phone.removeEventListener('change', syncMode);
      };

      root.addEventListener('click', function (event) {
        var columnOption = event.target.closest('[data-nutrition-col]');
        if (columnOption) {
          activeColumn = columnOption.dataset.nutritionCol;
          setColumn(columnOption.closest('.cns-nutri'), activeColumn);
          return;
        }

        var nutriToggle = event.target.closest('[data-nutri-toggle]');
        if (nutriToggle) {
          if (!phone.matches) return;
          var rows = document.getElementById(nutriToggle.getAttribute('aria-controls'));
          if (!rows) return;
          rows.hidden = !rows.hidden;
          nutriToggle.setAttribute('aria-expanded', rows.hidden ? 'false' : 'true');
          return;
        }

        var routeOption = event.target.closest('[data-prep-route]');
        if (routeOption) {
          var route = routeOption.dataset.prepRoute;
          var prep = routeOption.closest('[data-prep]');
          prep.querySelectorAll('[data-prep-route]').forEach(function (option) {
            option.setAttribute('aria-pressed', option === routeOption ? 'true' : 'false');
          });
          prep.querySelectorAll('[data-prep-route-panel]').forEach(function (panel) {
            panel.hidden = panel.dataset.prepRoutePanel !== route;
          });
          return;
        }

        var tab = event.target.closest('[data-label-tab]');
        if (tab) {
          var panel = panelOf(tab);
          if (!panel || !phone.matches) return;
          var opening = panel.hidden;
          tabs.forEach(function (other) {
            var otherPanel = panelOf(other);
            if (otherPanel) otherPanel.hidden = true;
          });
          panel.hidden = !opening;
          syncTabs();
        }
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-product-page]');
      if (root && root.cnsCleanup) root.cnsCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reorder"]) return;
  try {
    
  // Before the products go to the cart, the last order's delivery choice is
  // written to the cart's attributes, which the cart's delivery choice reads.
  // Without the script the form still adds the products; the cart then
  // starts on its default, the courier.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[data-reorder-delivery]') || form.dataset.sent) return;
    if (!window.fetch) return;
    event.preventDefault();
    // Marked at once, and the button busy: a second press while the
    // delivery choice saves would add the products twice (audit H052).
    form.dataset.sent = 'true';
    var button = form.querySelector('[type="submit"]');
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }
    var attributes = { 'Dostawa': form.dataset.reorderDelivery };
    attributes['Paczkomat'] = form.dataset.reorderLocker || '';
    attributes['Paczkomat adres'] = form.dataset.reorderLockerAddress || '';
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    };
    // At most 3 s: the products go to the cart even if this save hangs.
    if (window.AbortSignal && AbortSignal.timeout) options.signal = AbortSignal.timeout(3000);
    fetch(root + 'cart/update.js', options).catch(function () {}).then(function () {
      form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  // After a post the confirmation, or the error, takes focus, which also
  // scrolls it into view when the page reloads at the top.
  (() => {
    const result = document.querySelector('[data-newsletter-result]');
    if (result) result.focus();
  })();

  } catch(e) { console.error(e); }
})();
})();
